import React from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import * as queryString from 'querystring'

import PortalListFilterPanel from '../../templates/portal-list/PortalListFilterPanel'
import PortalListContainer from '../../templates/portal-list/PortalListContainer'
import PortalListLayout from '../../templates/portal-list/PortalListLayout'
import PortalListActionPanel from '../../templates/portal-list/PortalListActionPanel'
import withReduxModal from '../../../modules/redux-modal/redux/withReduxModal'
import withParams from '../../../modules/router-manage/withParams'

const initializeFilter = {
  title: '',
  tags: '',
  streetAddress: ''
}

class PortalListPage extends React.Component {
  state = {
    filter: initializeFilter,
    values: {
      towns: [],
      listings: [],
    },
  }

  async componentDidMount() {
    this.setFilter(this.props.params)
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(this.props.modal, prevProps.modal)) {
      const portalID = _.get(this.props, 'modal.closeParams.portalID')
      if (portalID) {
        this.props.history.push(`${portalID}/info`)
      }
    }

    if (!_.isEqual(this.props.params, prevProps.params)) {
      this.setFilter(this.props.params)
    }
  }

  setFilter(params) {
    const filter = _.pick(params, [
      'title',
      'tags',
      'streetAddress',
      'highlightSentence',
      'page',
      'limit',
    ])
    const page = _.parseInt(filter.page) || 1
    this.setState({ filter: { ...filter, page } })
  }

  createQueryString(newParams = {}) {
    const params = {
      ...this.props.params,
      ...newParams,
    }
    return queryString.stringify(params)
  }

  replacePage = (newParams = {}) => {
    this.props.history.replace(`?${this.createQueryString(newParams)}`)
  }

  handleFilterSubmit = filter => {
    this.replacePage(filter)
  }

  handleFilterClear = () => {
    this.replacePage(initializeFilter)
  }

  handlePageChange = page => {
    this.replacePage({ page })
  }

  render() {
    return (
      <PortalListLayout
        filterPanel={
          <PortalListFilterPanel
            onClearFilter={this.handleFilterClear}
            onSubmitFilter={this.handleFilterSubmit}
            values={this.state.values}
            filter={this.state.filter}
          />
        }
        actionPanel={<PortalListActionPanel />}
      >
        <PortalListContainer
          {...this.state}
          isAdmin={this.props.isAdmin}
          onPageChange={this.handlePageChange}
        />
      </PortalListLayout>
    )
  }
}

export default compose(
  withReduxModal,
  withParams,
)(PortalListPage)



// WEBPACK FOOTER //
// ./src/components/pages/web/PortalListPage.js